module.exports = __webpack_public_path__ + "icon-sms-75d38ccd6bd4022044ddd8c69484c208.svg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/bundles/ui/SharePhotoModal/ShareLink/icon-sms.svg
// module id = 1632
// module chunks = 3 6